import React, { useCallback, useState } from "react";
import { childrenProps } from "../common/types";
import useScrollTrigger from "../../hooks/useScrollTrigger";
import useMediaQuery from "../../hooks/useMediaQuerryHook";
import Navbar, { SmNavbar } from "./Navbar";
import { useTheme } from "../../context/ThemeContext";
import { MenuBtn } from "../ui/Icons";
import { AnimatePresence } from "framer-motion";
import SideMenu from "./SideMenu";
import Footer from "./Footer";

const PortfolioLayout: React.FC<childrenProps> = ({ children }) => {
  const { theme, toggleTheme } = useTheme();
  const [sideMenuOpen, setSideMenuOpen] = useState(false);

  const showMenu = useScrollTrigger();

  const isSmallScreen = useMediaQuery(576); // Check if the screen width is less than 576px moble
  const isTabletMode = useMediaQuery(768); // Check if the screen width is less than 768px tablet

  const toggleSideMenu = useCallback(() => {
    setSideMenuOpen((prev) => !prev);
  }, []);

  return (
    <>
      {isSmallScreen || isTabletMode ? (
        <SmNavbar
          toggleMenu={toggleSideMenu}
          isDarkMode={theme === "dark"}
          isSideMenuOpen={sideMenuOpen}
        />
      ) : (
        <Navbar toggleTheme={toggleTheme} isDarkMode={theme === "dark"} />
      )}

      {/* Routes come here */}
      {children}
      
      <Footer />

      {!isSmallScreen && (
        <MenuBtn
          isDarkMode={theme === "dark"}
          toggleMenu={toggleSideMenu}
          isSideMenuOpen={sideMenuOpen}
        />
      )}

      <AnimatePresence mode="wait">
        {(isSmallScreen || isTabletMode) && sideMenuOpen ? (
          <SideMenu
            open={sideMenuOpen}
            onClose={toggleSideMenu}
            isDarkMode={theme === "dark"}
            toggleTheme={toggleTheme}
          />
        ) : (
          showMenu &&
          sideMenuOpen && (
            <SideMenu
              open={sideMenuOpen}
              onClose={toggleSideMenu}
              isDarkMode={theme === "dark"}
              toggleTheme={toggleTheme}
            />
          )
        )}
      </AnimatePresence>
    </>
  );
};

export default PortfolioLayout;
